// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gvwhk","content":"styles_content__1LUU5"};